import { FIELDS_OF_STUDY } from "shared/pages/projectEdit/FieldsOfStudy";
import { TeamsList } from './teams';

export const projectStatus = [1, 10];
export const ROOT_ROUTE = '/';
export const DEFAULT_DESIGN_MAIN_ACTIVE_TAB = 'designers';
export const DEFAULT_MEDIA_ACTIVE_TAB = 'writers';
export const CONTEXT_START_FROM_ROOT = ['hsealumni', 'dafes', 'research', 'ageytomesh', 'main_geo', 'art_geo', 'art_deziiign', 'events_geo', 'creative_geo', 'academy_geo', 'places_geo'];
export const TEAMS_CONTEXTS = TeamsList;
export const CONTEXTS_WHERE_BTNS_HIDDEN = ['sound_deziiign', 'research', 'courses', 'design_geo', 'hse', 'main_geo', 'events_geo', 'art_geo', 'art_deziiign', 'places_geo', 'academy_geo', 'creative_geo', 'dafes', 'hsealumni', 'dpo',];
export const DARK_THEME = ['hsealumni', 'design_geo', 'art_geo', 'places_geo', 'main_geo', 'education_geo', 'events_geo', 'creative_geo', 'academy_geo'];
export const GEO_CONTEXTS = ['main_geo', 'dafes', 'hsealumni', 'design_geo', 'events_geo', 'places_geo', 'education_geo', 'art_geo', 'creative_geo', 'academy_geo'];
export const CONTEXT_WHERE_CANNOT_CREATE_PROJECT = ['hsealumni', 'dafes']
export const SUBSCRIPTION_CONTEXTS = ['hsegallery', 'hsestore']

export const examTabs = FIELDS_OF_STUDY.map(({
  label,
  value,
}) => ({
  path: value,
  name: label,
  filter: {
    contexts: [value]
  }
}))import { FIELDS_OF_STUDY } from "shared/pages/projectEdit/FieldsOfStudy";
import { TeamsList } from './teams';

export const projectStatus = [1, 10];
export const ROOT_ROUTE = '/';
export const DEFAULT_DESIGN_MAIN_ACTIVE_TAB = 'designers';
export const DEFAULT_MEDIA_ACTIVE_TAB = 'writers';
export const CONTEXT_START_FROM_ROOT = ['hsealumni', 'dafes', 'research', 'ageytomesh', 'main_geo', 'art_geo', 'art_deziiign', 'events_geo', 'creative_geo', 'academy_geo', 'places_geo'];
export const TEAMS_CONTEXTS = TeamsList;
export const CONTEXTS_WHERE_BTNS_HIDDEN = ['sound_deziiign', 'research', 'courses', 'design_geo', 'hse', 'main_geo', 'events_geo', 'art_geo', 'art_deziiign', 'places_geo', 'academy_geo', 'creative_geo', 'dafes', 'hsealumni', 'dpo',];
export const DARK_THEME = ['hsealumni', 'design_geo', 'art_geo', 'places_geo', 'main_geo', 'education_geo', 'events_geo', 'creative_geo', 'academy_geo'];
export const GEO_CONTEXTS = ['main_geo', 'dafes', 'hsealumni', 'design_geo', 'events_geo', 'places_geo', 'education_geo', 'art_geo', 'creative_geo', 'academy_geo'];
export const CONTEXT_WHERE_CANNOT_CREATE_PROJECT = ['hsealumni', 'dafes']
export const SUBSCRIPTION_CONTEXTS = ['hsegallery', 'hsestore']

export const examTabs = FIELDS_OF_STUDY.map(({
  label,
  value,
}) => ({
  path: value,
  name: label,
  filter: {
    contexts: [value]
  }
}))